import { Checkbox, Fieldset, ValidationMessage } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { useOppvarmingFormContext } from '../../../utils';
import { LeftPaddedContent } from '../../common/styledComponents';
import { TermostatstyringRadio } from '../../common/termostatstyringRadio';
import { useCommonValidation } from '../../../hooks/useCommonValidation';

export const Fordelingssystem = () => {
  const { register, watch, formState } = useOppvarmingFormContext();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming.common' });
  const { validateVarmefordeling } = useCommonValidation();

  const gulvvarmeSelected = watch(`varmepumpe.value.vannbarenVarme.gulvvarme.selected`);
  const radiatorSelected = watch(`varmepumpe.value.vannbarenVarme.radiator.selected`);

  const errors = formState.errors?.varmepumpe?.value?.vannbarenVarme;

  // Radiator and gulvvarme is validated as a group and share the exact same validation and error message.
  // We only display radiator error message.
  const fordelingssystemSelectionError = errors?.radiator?.selected;

  return (
    <Fieldset>
      <Fieldset.Legend>{t('kjel.fordelingssystem.label')}</Fieldset.Legend>
      <Checkbox
        aria-invalid={!!errors?.radiator?.selected}
        label={t('kjel.fordelingssystem.gulvvarme.label')}
        {...register(`varmepumpe.value.vannbarenVarme.gulvvarme.selected`, {
          validate: (_, { varmepumpe }) => validateVarmefordeling(varmepumpe?.value?.vannbarenVarme),
          deps: [`varmepumpe.value.vannbarenVarme.radiator.selected`]
        })}
      />
      {gulvvarmeSelected && (
        <LeftPaddedContent>
          <TermostatstyringRadio labelHidden name="varmepumpe.value.vannbarenVarme.gulvvarme.value.termostatstyring" />
        </LeftPaddedContent>
      )}

      <Checkbox
        aria-invalid={!!errors?.radiator?.selected}
        label={t('kjel.fordelingssystem.radiator.label')}
        {...register(`varmepumpe.value.vannbarenVarme.radiator.selected`, {
          validate: (_, { varmepumpe }) => validateVarmefordeling(varmepumpe?.value?.vannbarenVarme),
          deps: [`varmepumpe.value.vannbarenVarme.gulvvarme.selected`]
        })}
      />
      {radiatorSelected && (
        <LeftPaddedContent>
          <TermostatstyringRadio labelHidden name="varmepumpe.value.vannbarenVarme.radiator.value.termostatstyring" />
        </LeftPaddedContent>
      )}

      {fordelingssystemSelectionError && (
        <ValidationMessage>{fordelingssystemSelectionError.message}</ValidationMessage>
      )}
    </Fieldset>
  );
};
